import { createContext } from "react";

const dynamicPageContext = createContext();

export default dynamicPageContext;